import { useMemo } from 'react';

import { ProvisionNodesSetupSlide } from './custom-edge-location/ProvisionNodesSetupSlide';
import { ProvisionNodesConfigurationSlide } from './ProvisionNodesConfigurationSlide';
import { useProvisionNodesDrawerContext } from './ProvisionNodesDrawerContext';
import { ProvisionNodesDrawerSlides } from './types';
import { CUSTOM_EDGE_PROVIDER } from '../../constants';

export const useSteps = () => {
  const { edgeLocation } = useProvisionNodesDrawerContext();

  return useMemo(
    () => [
      {
        key: ProvisionNodesDrawerSlides.Configuration,
        label: 'Configure node',
        node: <ProvisionNodesConfigurationSlide />,
        show: true,
      },
      {
        key: ProvisionNodesDrawerSlides.Setup,
        label: 'Set up',
        node: <ProvisionNodesSetupSlide />,
        show: edgeLocation?.provider === CUSTOM_EDGE_PROVIDER,
      },
    ],
    [edgeLocation]
  );
};
